/* ============================================
   GIGLIOTTO TENUTE — Wine Card Gallery
   Loaded on any page that renders wine-card snippet
   ============================================ */

if (window.__wineGalleryInit) { /* guard */ } else {
  window.__wineGalleryInit = true;

  function goToSlide(productId, next) {
    const track = document.getElementById('wcg-' + productId);
    if (!track) return;
    const slides = track.querySelectorAll('.wcg-slide');
    const dots   = document.querySelectorAll('#wcg-dots-' + productId + ' .wcg-dot');
    let current  = parseInt(track.dataset.current || '0');
    current = (current + (next ? 1 : -1) + slides.length) % slides.length;
    track.dataset.current = current;
    track.style.transform = `translateX(-${current * 100}%)`;
    slides.forEach((s, i) => {
      const focusable = s.querySelector('a, img');
      if (focusable) focusable.tabIndex = i === current ? 0 : -1;
    });
    dots.forEach((d, i) => d.classList.toggle('active', i === current));
  }

  document.addEventListener('click', e => {
    const btn = e.target.closest('.wcg-btn');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    goToSlide(btn.dataset.wcg, btn.classList.contains('wcg-btn--next'));
  });

  let touchStartX = 0;
  document.addEventListener('touchstart', e => {
    const track = e.target.closest('.wcg-track');
    if (track) touchStartX = e.touches[0].clientX;
  }, { passive: true });

  document.addEventListener('touchend', e => {
    const track = e.target.closest('.wcg-track');
    if (!track) return;
    const diff = touchStartX - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 40) goToSlide(track.id.replace('wcg-', ''), diff > 0);
  });
}
